export default __webpack_public_path__ + "fa037b849fa8e66963aaeb2e56aa5957.png";